import React from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import type { SpendingData } from '../utils/SpendingData'

interface SpendingLegendProps {
  data: SpendingData
  onSelected: (id: string) => void
  selectedId: string
}

const SpendingLegend: React.FC<SpendingLegendProps> = ({ data, onSelected, selectedId }) => {
  const handleKeyDown = (event: React.KeyboardEvent, guid: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onSelected(guid)
    }
  }

  return (
    <Stack gap={8} height="100%" justifyContent="center" my="auto">
      {data.categoryData.map((item) => (
        <Stack
          alignItems="center"
          aria-label={item.name}
          aria-pressed={item.guid === selectedId}
          direction="row"
          gap={8}
          key={item.guid}
          onClick={() => onSelected(item.guid)}
          onKeyDown={(e) => handleKeyDown(e, item.guid)}
          role="button"
          sx={{ cursor: 'pointer', touchAction: 'manipulation' }}
          tabIndex={0}
        >
          <Box borderRadius={4} height={8} sx={{ backgroundColor: item.color }} width={8} />
          <Text bold={item.guid === selectedId} variant="caption">
            {item.name}
          </Text>
        </Stack>
      ))}
    </Stack>
  )
}

export default SpendingLegend
